// This file is auto-generated by @hey-api/openapi-ts

import { client } from './Client.gen';
import type { EshopFeeControllerGetByAliasData } from './EshopFeeControllerGetByAliasData.gen';
import type { EshopFeeControllerGetByAliasErrors } from './EshopFeeControllerGetByAliasErrors.gen';
import type { EshopFeeControllerGetByAliasResponses } from './EshopFeeControllerGetByAliasResponses.gen';
import type { Options } from './Options.gen';

export class EshopFeeController {
    /**
     * Get fee by alias.
     */
    public static getByAlias<ThrowOnError extends boolean = false>(options: Options<EshopFeeControllerGetByAliasData, ThrowOnError>) {
        return (options.client ?? client).get<EshopFeeControllerGetByAliasResponses, EshopFeeControllerGetByAliasErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/fees/{alias}',
            ...options
        });
    }
}
